/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Hatchery } from '../../models/hatchery';

export interface DeleteHatchery$Params {
  hatcheryId: number;
}

export function deleteHatchery(http: HttpClient, rootUrl: string, params: DeleteHatchery$Params, context?: HttpContext): Observable<StrictHttpResponse<Hatchery>> {
  const rb = new RequestBuilder(rootUrl, deleteHatchery.PATH, 'delete');
  if (params) {
    rb.path('hatcheryId', params.hatcheryId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Hatchery>;
    })
  );
}

deleteHatchery.PATH = '/api/hatchery/hatchery/{hatcheryId}';
